import React from 'react';

const Footer = () => {
    return (
        <div className="text-center text-white">
            <h2>Borderless Assistants</h2>
        </div>
    );
};

export default Footer;